import React from "react";

interface Props {
  size?: number;
  color?: string;
  className?: string;
}

export const FacebookIcon: React.FC<Props> = ({
  size = 24,
  color = "#1877F2",
  className = "",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M22.675 0H1.325C.593 0 0 .593 0 1.326v21.348C0 23.407.593 24 1.325 
      24H12.82v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.893-4.788 
      4.659-4.788 1.325 0 2.464.099 2.795.143v3.24l-1.918.001c-1.504 
      0-1.796.715-1.796 1.763v2.31h3.59l-.467 3.622h-3.123V24h6.116C23.407 
      24 24 23.407 24 22.674V1.326C24 .593 23.407 0 22.675 0z"/>
  </svg>
);
